import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
} from "../../../type/apiType";
import {
  IAPI_RET005_Request,
  IAPI_RET005_Response,
} from "../../../type/apiType";
import {
  IAPI_COM014_Request,
  IAPI_COM014_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照
const httpAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};

// 退職手当金請求更新
const httpAPI_RET005 = async (
  param: IAPI_RET005_Request
): Promise<IAPI_RET005_Response> => {
  let res = await http.post(ApiUrl.API_RET005, {
    ...param,
  });
  return res.data;
};

// ファイルダウンロード
const httpAPI_COM014 = async (
  param: IAPI_COM014_Request
): Promise<IAPI_COM014_Response> => {
  let res = await http.post(ApiUrl.API_COM014, {
    ...param,
  });
  return res.data;
};

export { httpAPI_STA003, httpAPI_RET005 ,httpAPI_COM014 };
